// CommunityForm.js
import React, { useState, useRef } from "react";
import { createCommunity } from "../api/community.js";
import "../css/CreateForm.css";


function CommunityForm({ onCreated, onClose, onCancel, setlang }) {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const mediaInputRef = useRef(null);
    const [image, setImage] = useState([]); 
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [preview, setPreview] = useState(null);

  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      setError("");
    
      try {
        const newCommunity = await createCommunity({
          name,
          description,
          image, 
        });
    
        if (onCreated) onCreated(newCommunity);
    
        setName("");
        setDescription("");
        setImage(null); 
    
        if (onClose) onClose();
      } catch (err) {
        setError(setlang==="en"?"Failed to create community.":"مشکلی در ایجاد گروه رخ داد، لطفا دوباره تلاش کن");
        //console.error("Create Community Error:", err.response?.status, err.response?.data);
      } finally {
        setLoading(false);
      }
    };
    
    return (
      <div className="PFProdForm-container">
        <button
          className="close-button"
          onClick={onClose}
        >
          ✕
        </button>
        {error && <p className="form-error">{error}</p>}

        <form onSubmit={handleSubmit}
        className="PFproduct-form"
        style={{display:'gird'}}>

          <h1>Create a Community</h1>
            <label className="com-label">
              Community Name
            </label>
            <input
              type="text"
              value={name}
              style={{gridColumn: 'span 2'}}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <label className="com-label">
              Description
            </label>
            <textarea
              value={description}
              style={{gridColumn: 'span 2', height:'8rem', }}
              onChange={(e) => setDescription(e.target.value)}
              rows="4"
            />
            
            {/* Media uploader (full width) */}
            <div className="media-upload">
              <label>
                Insert Community Image
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImage(e.target.files[0])} 
                  />
              </label>
            </div>

          <div className="button-container">
            <button type="submit" 
            disabled={loading}
            className="btn-primary" >
              {loading ? "Creating..." : "Create Community"}
            </button>
            <button type="button" className="btn-primary" onClick={onCancel}>Cancel</button>
          </div>

        </form>
      </div>
    );
  }
  
  export default CommunityForm;